"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionStorage = exports.useLocalStorage = void 0;
const react_1 = require("react");
function makeUseLocalStorageBrowser(which) {
    if (typeof window === "undefined")
        return undefined;
    const localStorage = which === "localStorage" ? window.localStorage : window.sessionStorage;
    return (keyName, defaultValue) => {
        const [value, setValueInternal] = (0, react_1.useState)();
        const [expiration, setExpiration] = (0, react_1.useState)();
        const setValueAndExpirationInternal = (0, react_1.useCallback)((value, expiration) => {
            if (value !== null && typeof value !== "undefined" && (!expiration || expiration > Date.now())) {
                setValueInternal(value);
                setExpiration(expiration);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(keyName, JSON.stringify({
                    value: value,
                    expiration,
                }));
                return true;
            }
            else {
                setValueInternal(undefined);
                setExpiration(undefined);
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(keyName);
                return false;
            }
        }, [keyName, setValueInternal, setExpiration]);
        (0, react_1.useEffect)(() => {
            const listener = (event) => {
                if (event.key === keyName) {
                    const storedValue = event.newValue;
                    if (storedValue) {
                        const { value, expiration } = JSON.parse(storedValue);
                        setValueAndExpirationInternal(value, expiration);
                    }
                    else {
                        setValueAndExpirationInternal(undefined, undefined);
                    }
                }
            };
            window.addEventListener("storage", listener);
            return () => {
                window.removeEventListener("storage", listener);
            };
        }, [keyName, setValueAndExpirationInternal]);
        (0, react_1.useEffect)(() => {
            if (expiration) {
                const expirationTimer = setTimeout(() => {
                    setValueAndExpirationInternal(undefined, undefined);
                }, expiration - Date.now());
                return () => {
                    clearTimeout(expirationTimer);
                };
            }
            return undefined;
        }, [value, expiration, setValueAndExpirationInternal]);
        const setValue = (0, react_1.useCallback)((newValue, ttl) => {
            let expiration = undefined;
            if (ttl) {
                if (ttl < 0)
                    throw new Error("TTL can't be negative");
                if (newValue === null || newValue === undefined)
                    throw new Error("TTL can't be set if value is null or undefined");
                expiration = Date.now() + ttl * 1000;
            }
            setValueAndExpirationInternal(newValue, expiration);
        }, [setValueAndExpirationInternal]);
        const initialized = (0, react_1.useRef)();
        if (!initialized.current) {
            initialized.current = true;
            const storedValue = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(keyName);
            if (storedValue) {
                const { value, expiration } = JSON.parse(storedValue);
                if (setValueAndExpirationInternal(value, expiration))
                    return [value, setValue];
            }
        }
        return [value !== undefined ? value : defaultValue, setValue];
    };
}
function makeUseLocalStorageStub() {
    return (_keyName, defaultValue) => {
        const [value, setValueInternal] = (0, react_1.useState)();
        const setValue = (0, react_1.useCallback)((newValue) => {
            setValueInternal(newValue);
        }, [setValueInternal]);
        return [value !== undefined ? value : defaultValue, setValue];
    };
}
exports.useLocalStorage = makeUseLocalStorageBrowser("localStorage") || makeUseLocalStorageStub();
exports.useSessionStorage = makeUseLocalStorageBrowser("sessionStorage") || makeUseLocalStorageStub();
//# sourceMappingURL=useLocalStorage.js.map